/** @type {import('../schema').ExperienceEntity[]} */
export const sxswSydneyEntities = [
  {
    id: 'sxsw-sydney',
    slug: 'sxsw-sydney',
    entityType: 'venue',
    name: 'SXSW Sydney',
    shortDescription: 'A gathering of innovators, entrepreneurs, creators, and technologists from around the world.',
    address: 'ICC Sydney, 14 Darling Drive',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8748,
    longitude: 151.1996,
  },
  {
    id: 'tumbalong-park',
    slug: 'tumbalong-park',
    entityType: 'venue',
    name: 'Tumbalong Park',
    shortDescription: 'The outdoor heart of the conference, with live concerts every afternoon.',
    address: '11 Harbour Street, Darling Harbour',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8756,
    longitude: 151.2027,
  },
  {
    id: 'teddy-swims-keynote',
    slug: 'teddy-swims-keynote',
    entityType: 'session',
    name: 'Teddy Swims In Conversation with Luke Conway',
    shortDescription: 'Teddy Swims and Luke Conway discussed their creative partnership and the work behind the music.',
    address: 'Darling Harbour Theatre, ICC Sydney, 14 Darling Drive',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8748,
    longitude: 151.1996,
  },
  {
    id: 'mo-gawdat-human-advantage-keynote',
    slug: 'mo-gawdat-human-advantage-keynote',
    entityType: 'session',
    name: 'The Human Advantage: Why AI Makes Us More, Not Less',
    shortDescription: 'A keynote by Mo Gawdat about the human qualities that matter most in an AI-shaped future.',
    address: 'Pyrmont Theatre, ICC Sydney, 14 Darling Drive',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8748,
    longitude: 151.1996,
  },
  {
    id: 'niall-firth-ai-in-2026',
    slug: 'niall-firth-ai-in-2026',
    entityType: 'session',
    name: 'Everything You Need to Know About AI in 2026',
    shortDescription: 'A session by Niall Firth exploring the near-term direction of artificial intelligence and what comes next.',
    address: 'ICC Sydney, 14 Darling Drive',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8748,
    longitude: 151.1996,
  },
  {
    id: 'w-sydney',
    slug: 'w-sydney',
    entityType: 'hotel',
    name: 'W Sydney',
    shortDescription: 'The crew’s Darling Harbour home base for the week.',
    address: '31 Wheat Road',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8730809,
    longitude: 151.2021841,
    websiteUrl: 'https://www.marriott.com/en-us/hotels/sydwh-w-sydney/overview/',
  },
  {
    id: 'coogee-bondi-walk',
    slug: 'coogee-to-bondi-coastal-walk',
    entityType: 'activity',
    name: 'Coogee to Bondi Coastal Walk',
    shortDescription: 'Cliffs, beaches, Pacific views, and Sculpture by the Sea along one of the world’s great coastal walks.',
    address: 'Coogee Surf Life Saving Club, Beach Street, Coogee',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.9232568,
    longitude: 151.2579747,
  },
  {
    id: 'manly-ferry',
    slug: 'ferry-to-manly',
    entityType: 'activity',
    name: 'Ferry to Manly Beach',
    shortDescription: 'An iconic ride across Sydney Harbour followed by an afternoon in Manly.',
    address: 'Manly Wharf, East Esplanade, Manly',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8000957,
    longitude: 151.2849153,
  },
  {
    id: 'exploring-the-rocks',
    slug: 'exploring-the-rocks',
    entityType: 'activity',
    name: 'Exploring The Rocks',
    shortDescription: 'A first-night pub discovery, a Day 2 pub crawl, and another stop after the Manly ferry outing.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.859992,
    longitude: 151.2083216,
  },
  {
    id: 'creativity-ai-future-work',
    slug: 'creativity-ai-future-work',
    entityType: 'session',
    name: 'Creativity, AI, and the Future of Work',
    shortDescription: 'An attended Monday-afternoon session about creativity and work in the age of AI.',
    address: 'Pyrmont Theatre, ICC Sydney, 14 Darling Drive',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8748,
    longitude: 151.1996,
  },
  {
    id: 'hands-on-lock-picking',
    slug: 'hands-on-lock-picking',
    entityType: 'session',
    name: 'Hands-On Lock Picking Session',
    shortDescription: 'A hands-on SXSW session where the crew learned how to pick locks.',
    address: 'ICC Sydney, 14 Darling Drive',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8748,
    longitude: 151.1996,
  },
  {
    id: 'no-algorithm-creativity',
    slug: 'no-algorithm-creativity',
    entityType: 'session',
    name: 'There Is No Algorithm For Creativity',
    shortDescription: 'An attended Tuesday session in Parkside 2.',
    address: 'Parkside 2, ICC Sydney, 14 Darling Drive',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8748,
    longitude: 151.1996,
  },
  {
    id: 'mobile-espionage',
    slug: 'mobile-espionage',
    entityType: 'session',
    name: 'Mobile Espionage: The Hidden Threats in Our Communications',
    shortDescription: 'An attended Tuesday session in Parkside 2.',
    address: 'Parkside 2, ICC Sydney, 14 Darling Drive',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8748,
    longitude: 151.1996,
  },
  {
    id: 'ai-first-future',
    slug: 'ai-first-future',
    entityType: 'session',
    name: 'Beyond the Myths: Building Your AI-First Future',
    shortDescription: 'An attended Tuesday-afternoon session in Pyrmont Theatre.',
    address: 'Pyrmont Theatre, ICC Sydney, 14 Darling Drive',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8748,
    longitude: 151.1996,
  },
  {
    id: 'paul-feig-conversation',
    slug: 'paul-feig-conversation',
    entityType: 'session',
    name: 'Paul Feig In Conversation',
    shortDescription: 'An attended Wednesday session in Darling Harbour Theatre.',
    address: 'Darling Harbour Theatre, ICC Sydney, 14 Darling Drive',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8748,
    longitude: 151.1996,
  },
  {
    id: 'cyber-intelligence-business',
    slug: 'cyber-intelligence-business',
    entityType: 'session',
    name: 'Trenchcoat Not Required: The Critical Role of Cyber Intelligence in Business',
    shortDescription: 'An attended Thursday-afternoon session in Cockle Bay 1.',
    address: 'Cockle Bay 1, ICC Sydney, 14 Darling Drive',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8748,
    longitude: 151.1996,
  },
  {
    id: 'manly-beach',
    slug: 'manly-beach',
    entityType: 'place',
    name: 'Manly Beach',
    shortDescription: 'A harbor ferry ride away from central Sydney, with ocean air, beach time, fish and chips, and local beer.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.7969,
    longitude: 151.2873,
  },
  {
    id: 'bondi-beach',
    slug: 'bondi-beach',
    entityType: 'place',
    name: 'Bondi Beach',
    shortDescription: 'The iconic finish to our first-day coastal walk from Coogee.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'blue-mountains',
    slug: 'blue-mountains',
    entityType: 'place',
    name: 'Blue Mountains',
    shortDescription: 'Rainforest, the Three Sisters, and sweeping views across Jamison Valley.',
    address: 'Lincoln’s Rock, Wentworth Falls',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.7405363,
    longitude: 150.3719179,
  },
  {
    id: 'scenic-world',
    slug: 'scenic-world',
    entityType: 'activity',
    name: 'Scenic World',
    shortDescription: 'The Scenic Railway, Skyway, and rainforest boardwalks gave the crew a different view of Australia.',
    address: '1 Violet Street, Katoomba',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.7289504,
    longitude: 150.3012638,
    websiteUrl: 'https://www.scenicworld.com.au/',
  },
  {
    id: 'featherdale-sydney-wildlife-park',
    slug: 'featherdale-sydney-wildlife-park',
    entityType: 'activity',
    name: 'Featherdale Sydney Wildlife Park',
    shortDescription: 'An up-close introduction to koalas, kangaroos, and other Australian wildlife on the return from the Blue Mountains.',
    address: '217 Kildare Road, Doonside',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.7661926,
    longitude: 150.8777122,
  },
  {
    id: 'the-rocks',
    slug: 'the-rocks',
    entityType: 'place',
    name: 'The Rocks',
    shortDescription: 'Historic lanes, harbor views, and pub stops explored after dinner.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'sydney-harbour',
    slug: 'sydney-harbour',
    entityType: 'place',
    name: 'Sydney Harbour',
    shortDescription: 'The Opera House, Harbour Bridge, ferries, and sunsets that framed the week.',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
  },
  {
    id: 'bondi-trattoria',
    slug: 'bondi-trattoria',
    entityType: 'restaurant',
    name: 'Bondi Trattoria',
    shortDescription: 'Beachfront Italian just steps from Bondi Beach.',
    address: '34 Campbell Parade, Bondi Beach',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8938662,
    longitude: 151.2728771,
  },
  {
    id: 'quay-sydney',
    slug: 'quay-sydney',
    entityType: 'restaurant',
    name: 'Quay',
    shortDescription: 'Fine dining overlooking the Opera House, Harbour Bridge, and Sydney Harbour.',
    address: 'Upper Level, Overseas Passenger Terminal, The Rocks',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8587227,
    longitude: 151.2100251,
    websiteUrl: 'https://www.quay.com.au/',
  },
  {
    id: 'glenmore-hotel',
    slug: 'glenmore-hotel',
    entityType: 'restaurant',
    name: 'Glenmore Hotel',
    shortDescription: 'A historic rooftop pub overlooking Sydney Harbour.',
    address: '96 Gloucester Street, The Rocks',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8587233,
    longitude: 151.2073996,
  },
  {
    id: 'fortune-of-war',
    slug: 'fortune-of-war-hotel',
    entityType: 'restaurant',
    name: 'Fortune of War Hotel',
    shortDescription: 'Australia’s oldest continually licensed pub.',
    address: '137 George Street, The Rocks',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.861471,
    longitude: 151.208076,
  },
  {
    id: 'australian-heritage-hotel',
    slug: 'australian-heritage-hotel',
    entityType: 'restaurant',
    name: 'Australian Heritage Hotel',
    shortDescription: 'A historic pub known for its Coat of Arms Pizza.',
    address: '100 Cumberland Street, The Rocks',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8596452,
    longitude: 151.2070221,
  },
  {
    id: 'harts-pub',
    slug: 'harts-pub',
    entityType: 'restaurant',
    name: 'Hart’s Pub',
    shortDescription: 'A pub stop during the Day 2 crawl through and around The Rocks.',
    address: '176 Cumberland Street, The Rocks',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8617756,
    longitude: 151.2063807,
  },
  {
    id: 'nine-dragons',
    slug: 'nine-dragons',
    entityType: 'restaurant',
    name: 'Nine Dragons',
    shortDescription: 'Traditional Cantonese dim sum in Sydney’s Chinatown.',
    address: 'Level 1, 39-45 Dixon Street, Haymarket',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8781515,
    longitude: 151.2040238,
  },
  {
    id: 'marrickville-hotel',
    slug: 'marrickville-hotel',
    entityType: 'restaurant',
    name: 'Marrickville Hotel',
    shortDescription: 'A casual neighborhood stop before the walk to dinner.',
    address: '244-246 Marrickville Road, Marrickville',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.9116004,
    longitude: 151.158269,
  },
  {
    id: '20-chapel',
    slug: '20-chapel',
    entityType: 'restaurant',
    name: '20 Chapel',
    shortDescription: 'A hidden dining destination and the unanimous group favorite.',
    address: '20 Chapel Street, Marrickville',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.9077358,
    longitude: 151.1655996,
  },
  {
    id: '4-pines-manly',
    slug: '4-pines-manly',
    entityType: 'restaurant',
    name: '4 Pines Brew Pub, Manly',
    shortDescription: 'The original 4 Pines brew pub, with beers and bar food before the nighttime ferry.',
    address: '43-45 East Esplanade, Manly',
    city: 'Manly',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.7996189,
    longitude: 151.2853646,
    websiteUrl: 'https://4pinesbeer.com.au/',
  },
  {
    id: 'mountain-culture',
    slug: 'mountain-culture-beer-co',
    entityType: 'restaurant',
    name: 'Mountain Culture Beer Co.',
    shortDescription: 'A Katoomba brewery stop between Scenic World and Featherdale.',
    address: '23-25 Parke Street, Katoomba',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.7122143,
    longitude: 150.3100149,
    websiteUrl: 'https://mountainculture.com.au/',
  },
  {
    id: 'bar-torino',
    slug: 'bar-torino',
    entityType: 'restaurant',
    name: 'Bar Torino',
    shortDescription: 'A pre-dinner stop before Margaret in Double Bay.',
    address: '24 Bay Street, Double Bay',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8749366,
    longitude: 151.2421616,
  },
  {
    id: 'margaret-sydney',
    slug: 'margaret-sydney',
    entityType: 'restaurant',
    name: 'Margaret',
    shortDescription: 'An acclaimed Sydney steakhouse built around exceptional food and hospitality.',
    address: '30-36 Bay Street, Double Bay',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.876866,
    longitude: 151.241543,
    websiteUrl: 'https://margaretdoublebay.com/',
  },
  {
    id: 'blackbird-cafe',
    slug: 'blackbird-cafe',
    entityType: 'restaurant',
    name: 'Blackbird Cafe',
    shortDescription: 'A waterfront late lunch and early dinner stop after the Monday conference sessions.',
    address: 'Balcony Level 1, Cockle Bay Wharf, Wheat Road',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.87257,
    longitude: 151.20205,
    websiteUrl: 'https://blackbirdcafe.com.au/',
  },
  {
    id: 'sydney-fish-market',
    slug: 'sydney-fish-market',
    entityType: 'restaurant',
    name: 'Sydney Fish Market',
    shortDescription: 'A Wednesday lunch of fresh sushi and whole grilled fish at the former Pyrmont market site.',
    address: '25 Bank Street, Pyrmont',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8731473,
    longitude: 151.1925552,
    websiteUrl: 'https://www.sydneyfishmarket.com.au/',
  },
  {
    id: 'orient-hotel-sydney',
    slug: 'orient-hotel-sydney',
    entityType: 'restaurant',
    name: 'Orient Hotel Sydney',
    shortDescription: 'The Wednesday-night pint after the crew passed Fortune of War without stopping.',
    address: '87-89 George Street, The Rocks',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8590585,
    longitude: 151.2086248,
    websiteUrl: 'https://www.orienthotel.com.au/',
  },
  {
    id: 'adria-sydney',
    slug: 'adria-sydney',
    entityType: 'restaurant',
    name: 'Adria',
    shortDescription: 'A casual Thursday lunch on the Darling Harbour waterfront between conference sessions.',
    address: 'The Promenade, Cockle Bay Wharf, Darling Harbour',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.87279,
    longitude: 151.20218,
    websiteUrl: 'https://www.nicksgroup.com.au/venue/adria-bar-restaurant/',
  },
  {
    id: 'stitch-sydney',
    slug: 'stitch-sydney',
    entityType: 'restaurant',
    name: 'Stitch',
    shortDescription: 'Friday-night dinner after the Blue Mountains excursion and Olympic Park ferry.',
    address: '61 York Street',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.8674641,
    longitude: 151.2056559,
    websiteUrl: 'https://www.houseofpocket.com.au/stitchbar',
  },
  {
    id: 'pj-obriens-sydney',
    slug: 'pj-obriens-sydney',
    entityType: 'restaurant',
    name: 'PJ O’Brien’s',
    shortDescription: 'A pint while walking back to W Sydney from Stitch on Friday night.',
    address: '57 King Street',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.86879,
    longitude: 151.20476,
    websiteUrl: 'https://www.pjobriens.com.au/sydney/',
  },
  {
    id: 'sydney-pub-crawl',
    slug: 'sydney-pub-crawl',
    entityType: 'restaurant',
    name: 'Sydney Pub Crawl',
    shortDescription: 'Historic pubs, rooftop bars, harbor-side pints, and neighborhood favorites discovered throughout the week.',
    address: 'The Rocks',
    city: 'Sydney',
    region: 'New South Wales',
    country: 'Australia',
    latitude: -33.859992,
    longitude: 151.2083216,
  },
];

export const sxswSydneyEntityById = sxswSydneyEntities.reduce((entities, entity) => ({
  ...entities,
  [entity.id]: entity,
}), {});
